"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFinalAnnouncementList = exports.createAnnouncementsList = void 0;

var _AnnouncementsConstants = _interopRequireDefault(require("../constants/AnnouncementsConstants"));

var _dateformat = _interopRequireDefault(require("dateformat"));

var _store = _interopRequireDefault(require("../store/store"));

var AnnouncementSelectors = _interopRequireWildcard(require("../store/reducers/AnnouncementReducer"));

/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

/**
 * Find the list of products the user has access to.
 * Maps service ID's with the name of the product and checks if the product is available with the user.
 *
 * @param {JSONObject} Status : data from status.adobe.com.
 */
var findServiceIdOfUserProducts = function findServiceIdOfUserProducts(Status) {
  var JSONOutput = [];

  if (Status && Status.localizationValues && Status.localizationValues.en && Status.localizationValues.en.localizeValues) {
    (function () {
      var localizedValues = Status.localizationValues.en.localizeValues;
      var userEntitlements = AnnouncementSelectors.getUserEntitlements(_store.default.getState());

      var _loop = function _loop(id) {
        if (JSON.stringify(id).includes('serviceName')) {
          userEntitlements.forEach(function (userEntitlement) {
            if (JSON.stringify(localizedValues[id]).includes(userEntitlement.longName)) {
              JSONOutput.push(id);
            }
          });
        }
      };

      for (var id in localizedValues) {
        _loop(id);
      }
    })();
  }

  return JSONOutput;
};
/**
 * Compares two announcements based on timestamps.
 *
 * @param {Announcement} a
 * @param {Announcement} b
 */


var timestampComparator = function timestampComparator(a, b) {
  return Math.sign(b.createTimeStamp - a.createTimeStamp);
};
/**
 * Sorts the list of Announcements based on timestamp.
 *
 * @param {JSONArray} AnnouncementsList List of announcements parsed from status.adobe.com.
 */


var sortByTimeStamp = function sortByTimeStamp(AnnouncementsList) {
  return AnnouncementsList.sort(timestampComparator);
};
/**
 * Maps the message keycodes with their respective values.
 *
 * @param {string} keystring  Key which needs to mapped to the message value.
 * @param {JSONObject} Status  Data from status.adobe.com.
 */


var replaceCodesWithValues = function replaceCodesWithValues(keystring, Status) {
  return Status.localizationValues.en.localizeValues[keystring];
};
/**
 * Maps the message keycodes with their respective values.
 *
 * @param {string} keystring  Key which needs to mapped to the message value.
 * @param localizationdata
 * @param {JSONObject} Status  Data from status.adobe.com.
 */


var replaceCodesWithLocalizedValues = function replaceCodesWithLocalizedValues(keystring, localizationdata, Status) {
  if (localizationdata.localizeValues && localizationdata.localizeValues[keystring]) {
    return localizationdata.localizeValues[keystring];
  }

  return replaceCodesWithValues(keystring, Status);
};
/**
 * Gets the actual message value for the message keycode
 * replaces date-time placeholders with actual values.
 *
 * @param {string} message Message keycode for the event.
 * @param {Date} startTime Start date-time of the event.
 * @param {Date} endTime End date-time of the event.
 * @param {JSONObject} Status Data from status.adobe.com.
 */


var parseMessageValue = function parseMessageValue(message, startTime, endTime, localizationdata, Status) {
  var localizedVal = replaceCodesWithLocalizedValues(message, localizationdata, Status);
  return localizedVal && localizedVal.replace('{startDateTime}', startTime).replace("{endDateTime}", endTime);
};
/**
 * Converts date in time stamp to required format
 * Format saved in Constants.
 *
 * @param {timestamp} dateinTS
 */


var parseDate = function parseDate(dateinTS) {
  var now = new Date(dateinTS * 1000);
  return (0, _dateformat.default)(now, _AnnouncementsConstants.default.relatedDateFormat);
};
/**
 * Filters out announcements for only the products user has access to.
 *
 * @param {JSONArray} userServiceIds List if service IDs of products user has access to.
 * @param {JSONObject} Status Data from status.adobe.com.
 */


var extractStatusForUserProducts = function extractStatusForUserProducts(userServiceIds, Status) {
  var extractedStatus = [];
  Status.products.forEach(function (product) {
    if (userServiceIds.includes(product.service.name.token)) {
      extractedStatus.push(product);
    }
  });
  return extractedStatus;
};
/**
 * Get the list of impacted services for each announcement.
 *
 * @param {JSONObject} announcement Name says it all.
 * @param {JSONArray} Status Data from status.adobe.com.
 * @param localizationdata
 */


var parseImpactedServices = function parseImpactedServices(announcement, Status, localizationdata) {
  var impactedServicesList = [];

  if (announcement.impactedServices) {
    announcement.impactedServices.forEach(function (service) {
      if (service.name && service.name.token) {
        impactedServicesList.push(replaceCodesWithLocalizedValues(service.name.token, localizationdata, Status));
      }
    });
  }

  return impactedServicesList;
};
/**
 * Parse the announcements associated with the parent announcement.
 *
 * @param {JSONObject} announcement The parent announcement.
 * @param {JSONArray} Status Data from status.adobe.com.
 * @param localizationdata
 */


var parseRelatedAnnouncements = function parseRelatedAnnouncements(announcement, Status, localizationdata) {
  var relatedAnnouncementsList = [];

  if (announcement.messages.length > 0) {
    announcement.messages.slice(1).forEach(function (serviceMessage) {
      relatedAnnouncementsList.push({
        title: replaceCodesWithLocalizedValues(serviceMessage.title.token, localizationdata, Status),
        message: replaceCodesWithLocalizedValues(serviceMessage.message.token, localizationdata, Status),
        createtimestamp: serviceMessage.createdAt
      });
    });
  }

  return relatedAnnouncementsList;
};
/**
 * Create a list of announcements from status.adobe.com according to user permissions.
 *
 * @param products
 * @param Status
 * @param localizationdata
 */


var createAnnouncementsList = function createAnnouncementsList(products, Status, localizationdata) {
  var AnnouncementsList = [];
  var startTime;
  var endTime;
  var index = 0;
  products.forEach(function (product) {
    _AnnouncementsConstants.default.EventTypes.forEach(function (type) {
      if (product[type] && product[type].length != 0) {
        product[type].forEach(function (task) {
          startTime = task.startTime ? parseDate(task.startTime) : 0;
          endTime = task.endTime ? parseDate(task.endTime) : 0;
          AnnouncementsList[index] = {};

          if (product.service && product.service.name && product.service.name.token) {
            var productName = replaceCodesWithLocalizedValues(product.service.name.token, localizationdata, Status); // TODO remove this when ANS/UNS starts giving product name in sync with announcement

            productName = productName.startsWith('Adobe') ? productName.replace('Adobe', '') : productName;
            AnnouncementsList[index].serviceName = productName.trim();
          } else {
            AnnouncementsList[index].serviceName = '';
          }

          if (task && task.messages && task.messages.length > 0 && task.messages[0].title && task.messages[0].title.token) {
            AnnouncementsList[index].messageTitle = replaceCodesWithLocalizedValues(task.messages[0].title.token, localizationdata, Status);
          } else {
            AnnouncementsList[index].messageTitle = '';
          }

          if (task && task.messages && task.messages.length > 0 && task.messages[0].message && task.messages[0].message.token) {
            AnnouncementsList[index].messageContent = parseMessageValue(task.messages[0].message.token, startTime, endTime, localizationdata, Status);
          } else {
            AnnouncementsList[index].messageContent = '';
          }

          if (task && task.messages && task.messages.length > 0 && task.messages[0].createdAt) {
            AnnouncementsList[index].createTimeStamp = task.messages[0].createdAt;
          } else {
            AnnouncementsList[index].createTimeStamp = Date.now();
          }

          if (task && task.eventType) {
            AnnouncementsList[index].eventType = _AnnouncementsConstants.default.EventTypeMapping[task.eventType];
          } else {
            AnnouncementsList[index].eventType = _AnnouncementsConstants.default.EventTypeMapping[0];
          }

          AnnouncementsList[index].related = parseRelatedAnnouncements(task, Status, localizationdata);
          AnnouncementsList[index].impactedservices = parseImpactedServices(task, Status, localizationdata);
          AnnouncementsList[index].productid = product && product.service ? product.service.id : 1172; //1172 is service id for experience cloud

          AnnouncementsList[index].announcementid = task ? task.id : 0;
          index++;
        });
      }
    });
  });
  return sortByTimeStamp(AnnouncementsList);
};
/**
 * Will return the parsed list of announcements.
 *
 * @param data
 * @param localizationdata
 */


exports.createAnnouncementsList = createAnnouncementsList;

var getFinalAnnouncementList = function getFinalAnnouncementList(data, localizationdata) {
  var AnnouncementsList = [];
  var userServiceIds = [];
  var extractedStatusForUserProducts = [];

  if (data.products && data.products.length) {
    userServiceIds = findServiceIdOfUserProducts(data);
    extractedStatusForUserProducts = extractStatusForUserProducts(userServiceIds, data);
    AnnouncementsList = createAnnouncementsList(extractedStatusForUserProducts, data, localizationdata);
  }

  return AnnouncementsList;
};

exports.getFinalAnnouncementList = getFinalAnnouncementList;